import React from 'react';
import Crossword from '@jaredreisinger/react-crossword';

const CrosswordExample = () => {
  const data = {
    across: {
      1: {
        clue: 'one plus one',
        answer: 'TWO',
        row: 0,
        col: 0,
      },
    },
    down: {
      2: {
        clue: 'three minus two',
        answer: 'ONE',
        row: 0,
        col: 2,
      },
    },
  };

  return (
    <div>
      <div style={{position: "relative", textAlign: "center"}}>
        <iframe 
          height="700px" 
          width="100%" 
          allow="web-share; fullscreen" 
          style={{border: "none", width: "100% !important", position: "static", display: "block !important", margin: "0 !important"}} 
          src="https://puzzleme.amuselabs.com/pmm/crossword?id=24f0cb5f&set=a1480010a29556020fdfa018b6fb28602689085a55a2382d9a0c7f99864bbc4d&embed=1" 
          aria-label="Puzzle Me Game"
        />
        <div className="pm-attribution-div" style={{fontFamily: "sans-serif", fontSize: "12px", color: "rgb(102, 102, 102)", position: "absolute", top: "100%", left: "50%", transform: "translate(-50%, 0px)", paddingTop: "5px", width: "100%"}}>
          Built by Theodore Lampert using PuzzleMe's free <a href="https://amuselabs.com/games/crossword/" target="_blank" style={{color: "#666666", textDecoration: "underline"}}>crossword puzzle creator</a>
        </div>
      </div>
    </div>
  );
};

export default CrosswordExample;
